module.exports = __webpack_public_path__ + "img/sy.16bdd250.svg";